module.exports = __webpack_public_path__ + "media/assets/images/page_title_illustration_about_us-fb8d6ef51cfcb84d75e9d4d58d0b6b2c.png";